import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Ban } from "lucide-react";
import { useState } from "react";
import { cancelAbsence } from "@/Api/absences";
import { useToastNavigate } from "@/utils/toastNavigate";
import { LoaderSpin } from "@/components/Loaders";

export const CancelAbsenceBtn = ({
  uuid,
  onCancelled,
}: {
  uuid: string;
  onCancelled: () => void;
}) => {
  const { toast } = useToastNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [note, setNote] = useState("");
  const [cancelling, setCancelling] = useState(false);

  const handleCancel = async () => {
    if (note.trim().length < 5) return;
    setCancelling(true);
    const { data, ok } = await cancelAbsence(uuid, note);
    setCancelling(false);
    if (!ok) {
      toast({
        description: data?.message || "Erro ao cancelar",
        variant: "destructive",
      });
      return;
    }
    setIsOpen(false);
    setNote("");
    toast({ description: "Abono cancelado." });
    onCancelled();
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button type="button" size="sm" variant="outline">
          <Ban className="size-4" />
          Cancelar
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogDescription className="text-lg">
            Motivo do cancelamento
          </DialogDescription>
        </DialogHeader>
        <Textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Explique por que esse abono está sendo cancelado (mín. 5 caracteres)"
        />
        <DialogFooter>
          <Button
            type="button"
            variant="destructive"
            className="w-full"
            disabled={cancelling || note.trim().length < 5}
            onClick={handleCancel}
          >
            {cancelling ? <LoaderSpin /> : "Confirmar cancelamento"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
